export const rackFormField = {
  bay: "bay",
  city: "city",
  number: "number",
  row: "row",
} as const;
